import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";
import { Element, scroller } from "react-scroll";

const Chapter1_4 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was ist das Ziel des Zugangsmanagements?",
      options: [
        {
          value: "A",
          label:
            "Sicherstellen, dass nur autorisierte Benutzer auf IT-Systeme und Daten zugreifen.",
        },
        {
          value: "B",
          label:
            "Sicherstellen, dass auch nicht autorisierte Benutzer auf IT-Systeme und Daten zugreifen können.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Was ist das Hauptprinzip der rollenbasierten Zugriffskontrolle (RBAC)?",
      options: [
        {
          value: "A",
          label:
            "Berechtigungen werden basierend auf vordefinierten Rollen wie z. B. Mitarbeiter oder Administrator vergeben.",
        },
        {
          value: "B",
          label:
            "Berechtigungen werden individuell für jeden Benutzer separat festgelegt.",
        },
      ],
      correct: "A",
    },
  ];

  
  const location = useLocation(); 
  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 1_4.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "1_4",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("1_4"),
            });
          console.log("Dokument aktualisiert mit Kapitel 1_4.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "1_4",
              completedChapters: ["1_4"],
            });
          console.log("Dokument erstellt mit Kapitel 1_4.");
        }

        navigate("/1_5"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  Was ist Cybersecurity?
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Zugriffsmanagement
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">Kapitel 1: Was ist Cybersecurity?</h3>
          <h2 className="text-center p-3">Zugriffsmanagement</h2>
          <img
            src="/images/access.webp"
            alt="Access"
            style={{ position: "relative", maxWidth: "20%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">Zugriffsmanagement (Access Control)</h2>
          <p className="col-lg-11 mx-auto">
            Um die Integrität, Vertraulichkeit und Verfügbarkeit von Daten zu
            erreichen, ist die Sicherheit dieser Daten natürlich eine
            Grundvoraussetzung. Bricht die digitale Datenbasis weg, ist im
            schlimmsten Fall das komplette Unternehmen handlungsunfähig. Dabei
            sind Cyberangriffe die Hauptursache für Datenverluste. Natürlich
            gibt es auch Schaden durch fehlerhafte Hardware, Stromausfälle,
            Bedienungsfehler usw. Die größte Gefahr bleibt aber der illegale
            Zugriff auf die Daten.
            <br />
            <br />
            Eine wesentliche Gegenmaßnahme ist ein gutes{" "}
            <strong> Zugriffsmanagement. </strong>
            Damit wird sichergestellt, dass nur
            <strong> autorisierte Identitäten </strong> (Personen oder Systeme,
            z. B. Drucker) auf bestimmte Daten/Ressourcen zugreifen können.{" "}
          </p>
          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />{" "}
            80% aller Cyberattacken verwenden identitätsbasierte
            Angriffstechniken. (CrowdStrike) Das bedeutet: In vier von fünf Fällen verschaffen sich Angreifer über kompromittierte Zugangsdaten, gestohlene Tokens oder missbrauchte Berechtigungen Zugang zu Systemen – nicht über klassische Schadsoftware, sondern über legitime Identitäten.
          </p>

          <p className="col-lg-11 mx-auto">
            Durch ein effektives Zugriffsmanagement werden Sicherheitsrisiken
            minimiert und Compliance-Anforderungen erfüllt. <br />
            <br />
            Das Zugriffsmanagement reglementiert und definiert die drei
            Bereiche:
            <strong> Zutrittskontrolle, </strong>{" "}
            <strong>Zugangskontrolle</strong> und{" "}
            <strong>Zugriffskontrolle.</strong>
          </p>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container">
          <div className="p-5 text-center">
            <h2 className="p-5">Zutrittskontrolle - Wer darf rein?</h2>

            <p className="col-lg-11 mx-auto">
              Die <strong>Zutrittskontrolle (Physical Access Control), </strong>{" "}
              regelt, wer physisch Zugang zu einem Gebäude, Raum oder Gelände
              erhält. Sie verhindert, dass unbefugte Personen in sensible
              Bereiche gelangen. Sicherheitskarten oder Schlüssel für Türen,
              Biometrische Scanner (z. B. Fingerabdruck, Gesichtserkennung) oder
              Überwachungskameras und Pförtner schützen vor physischen
              Bedrohungen wie Diebstahl, Sabotage oder dem Zugriff auf sensible
              Hardware wie Server.
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />{" "}
              Der weltweite Markt für Zugangskontrollsysteme wächst weiter deutlich. Prognosen gehen davon aus, dass das Marktvolumen von rund 10,6 Mrd. USD (2025) auf etwa 15,8 Mrd. USD (2030) steigen wird – bei einem jährlichen Wachstum von über 8 %. (MarketsandMarkets - "Access Control Market" - Forecast to 2025 - 2030)
            </p>
          </div>
        </div>
      </div>
      <div className="grey-section">
        <div className="container">
          <div className="p-5 text-center">
            <h2 className="p-5">Zugangskontrolle - Wer darf sich anmelden?</h2>

            <p className="pb-5 col-lg-11 mx-auto">
              Die <strong>Zugangskontrolle (Logical Access Control) </strong>{" "}
              ist ein zentraler Bestandteil der IT-Sicherheitsstrategie eines
              Unternehmens oder einer Organisation. Sie regelt, wer auf ein
              Netzwerk, ein System oder eine Anwendung zugreifen darf und sorgt
              dafür, dass nur autorisierte Personen oder Geräte diesen Zugang
              erhalten. Ziel der Zugangskontrolle ist es, sensible Daten und
              Systeme vor unbefugtem Zugriff zu schützen und die Einhaltung
              gesetzlicher Vorschriften, wie z. B. der DSGVO, sicherzustellen.
              <br />
              <br />
              Die Zugangskontrolle basiert auf drei zentralen Prozessen:
              Identifikation, Authentifizierung und Autorisierung.
            </p>

            <section class="pb-5 col-lg-10 mx-auto text-start">
              <ul class="timeline">
                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">Identifikation:</h5>

                  <p>
                    Der Benutzer gibt seine Identität an, beispielsweise durch
                    einen Benutzernamen, eine E-Mail-Adresse oder eine
                    biometrische Erkennung wie einen Fingerabdruck.
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">Authentifizierung:</h5>

                  <p>
                    Die Identität des Benutzers wird überprüft. Das kann durch
                    wissensbasierte Authentifizierung passieren (Passwort oder
                    Pin), durch besitzbasierte Authentifizierung ( Smartphone
                    oder Token), durch biometrische Authentifizierung (Iris-Scan
                    oder Fingerprint) oder durch Multi-Faktor-Authentifizierung:
                    Kombination aus mindestens zwei der oben genannten Methoden.
                    Beispiel: Passwort (Wissen) + SMS-Code (Besitz).
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">Autorisierung:</h5>

                  <p>
                    Nach erfolgreicher Authentifizierung wird entschieden, ob
                    der Benutzer tatsächlich berechtigt ist, auf das
                    angeforderte System oder die Daten zuzugreifen.
                  </p>
                </li>
              </ul>
            </section>

            <h4 className="p-3">Arten der Zugangskontrolle</h4>
            <p className="pb-5 col-lg-11 mx-auto">
              Es gibt verschiedene Modelle, wie die Zugangskontrolle umgesetzt
              werden kann. Die Wahl der Methode hängt von den Anforderungen des
              Unternehmens und der Sensibilität der zu schützenden Daten ab.
              <br />
              <br />
              <strong>
                {" "}
                Rollenbasierte Zugangskontrolle (Role-Based Access Control,
                RBAC): <br />
                <br />
              </strong>
              Berechtigungen werden basierend auf der Rolle oder
              Berufsbezeichnung des Benutzers automatisch vergeben (z. B.
              "Mitarbeiter", "Manager", "Administrator").{" "}
              <em>
                Beispiel: Ein Mitarbeiter kann auf allgemeine Dokumente
                zugreifen, ein Administrator hingegen auf alle Daten und
                Systeme.
              </em>
              <br />
              <br />
              <strong>
                Attributbasierte Zugangskontrolle (Attribute-Based Access
                Control, ABAC):{" "}
              </strong>
              <br />
              <br />
              Entscheidungen basieren auf bestimmten Attributen des Benutzers
              oder der Anfrage (z. B. Abteilung, Standort, Gerätetyp). Die
              Freigaben werden dynamisch erteilt.{" "}
              <em>
                Beispiel: Ein Mitarbeiter in der Personalabteilung erhält nur
                Zugriff auf Daten von Mitarbeitern seines Standorts.
              </em>{" "}
              Da hier sehr viele unterschiedliche und miteinander verknüpfte
              Zugangsberechtigungen verteilt werden, ist dieses Modell sehr
              schwer zu implementieren.
              <br />
              <br />
              <strong>Mandatory Access Control (MAC): </strong>
              <br />
              <br />
              Mandatory Access Control kommt überall dort zum Einsatz, wo
              strenge Sicherheitsvorgaben oder hohe Datenschutzanforderungen
              einzuhalten sind. Typische Anwendungsbereiche sind
              Zugriffskontrollen auf IT-Systemen von Regierungsbehörden,
              medizinischen Einrichtungen, Finanzinstituten oder militärischen
              Einrichtungen.{" "}
              <em>
                Beispiel: Nur Benutzer mit einer bestimmten Sicherheitsfreigabe
                können auf vertrauliche Dokumente zugreifen.{" "}
              </em>
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container">
          <div className="p-5 text-center">
            <h2 className="p-5">Zugriffskontrolle: Wer darf was sehen?</h2>

            <p className="pb-5 col-lg-11 mx-auto">
              Während die Zugangskontrolle regelt, wer in ein System
              hineinkommt, befasst sich die{" "}
              <strong>Zugriffskontrolle (Permission Management) </strong> damit,
              was dieser Nutzer innerhalb des Systems tun darf.
              <br />
              <br />
              Die Zugriffskontrolle basiert auf zwei grundlegenden Prinzipien:
              <br />
              <br />
              <strong>Minimalprinzip (Principle of Least Privilege): </strong>
              Benutzer erhalten nur die minimalen Rechte, die sie benötigen, um
              ihre Aufgaben zu erfüllen. Dadurch wird das Risiko begrenzt, dass
              ein Benutzer versehentlich oder absichtlich Schaden anrichtet.{" "}
              <br />
              <br />
              <strong>Need-to-Know-Prinzip: </strong>
              Benutzer dürfen nur auf die Informationen zugreifen, die sie für
              ihre Arbeit benötigen. Dies minimiert die Angriffsfläche für
              potenzielle Datenverluste.
              <br />
              <br />
              Ergänzt und verschärft werden beide Prinzipien noch durch
              Just-in-Time- und Just-Enough-Access-Richtlinien. <br />
              <br />
              Der <strong> Just-in-Time-Zugriff (JIT) </strong> gewährt
              Berechtigungen nur bei Bedarf und für einen begrenzten Zeitraum.
              <br />
              <br />
              <strong>Just-Enough-Access (JEA) </strong> stellt sicher, dass
              Benutzer nur auf die spezifischen Ressourcen zugreifen können, die
              sie tatsächlich benötigen. Durch die Kombination von JIT und JEA
              wird die Angriffsfläche nochmal minimiert. Das Risiko von
              Datenschutzverletzungen durch gehackte Benutzerkonten wird
              reduziert.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Trotz sorgfältiger Planung können Schwachstellen in der
              Zugriffskontrolle auftreten, die von Angreifern ausgenutzt werden.
              Wenn Benutzer zu viele Rechte erhalten, können sie absichtlich
              oder versehentlich Schaden anrichten. Alte oder inaktive
              Benutzerkonten können unbefugt weiter genutzt werden. Schlechte
              Implementierungen oder ungenaue Berechtigungen können Sicherheitslücken
              schaffen.
            </p>
          </div>
        </div>

        <div className="container pb-5">
          <div className="container mt-5">
            <div
              className="safe rounded-2 text-center"
              style={{ backgroundColor: "#fec748" }}
            >
              <img
                src="/images/abwehr.svg"
                alt="Abwehr"
                style={{
                  position: "relative",
                  maxWidth: "7%",
                  height: "auto",
                }}
              />
              <h3 className="p-5"> Identity und Access Management (IAM)</h3>
              <Element name="iam">
                <p className="col-lg-11 mx-auto">
                  Je mehr Benutzer und Applikationen ein Unternehmensnetzwerk
                  umfasst, desto komplexer, zeitaufwändiger und fehleranfälliger
                  gestalten sich die manuelle Benutzer und
                  Berechtigungsverwaltung. Unternehmen setzen daher zunehmend
                  auf ein Identity and Access Management (IAM).
                  <br />
                  <br /> Unter Identity und Access Management versteht man in
                  der IT alle Aufgaben rund um die Verwaltung von digitalen
                  Identitäten (Identity) und den damit verknüpften
                  Zugriffsrechten (Access).
                  <br />
                  <br />
                  IAM ist ein System, das Unternehmen dabei unterstützt,
                  Benutzeridentitäten und Zugriffsrechte effizient zu verwalten.
                  Es automatisiert Aufgaben wie die Zugangserteilung oder
                  -entziehung und regelt, wer auf welche Daten oder Anwendungen
                  zugreifen darf. Dabei hilft ein IAM bei der Bearbeitung dieser Aufgaben:
                  <br />
                  <br />
                  <strong>
                    Automatisierung statt manueller Zugangsrechtevergabe:{" "}
                  </strong>
                  IAM-Systeme übernehmen die zeitintensive Verwaltung von Konten
                  und Berechtigungen, wie das Anlegen neuer Nutzer oder das
                  Entziehen von Zugriffsrechten bei Ausscheiden eines
                  Mitarbeiters.
                  <br />
                  <br />
                  <strong>Klar definierte Prozesse: </strong>
                  Statt mühsamer Einzelfallentscheidungen ermöglicht IAM eine
                  einheitliche und transparente Vergabe von Zugriffsrechten.
                  <br />
                  <br />
                  <strong>Vermeidung von Sicherheitslücken: </strong>
                  Durch Automatisierung und klare Richtlinien verhindert IAM
                  typische Fehler, wie z. B. vergessene Zugangsrechte bei ehemaligen
                  Mitarbeitern oder übermäßig großzügige Berechtigungen.
                </p>
                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />{" "}
                  Ein funktionierendes Identity und Access Management ist die am häufigsten genannte
                  Anforderung, um eine Cyberversicherung abschließen zu können.
                  (Delinea)
                </p>
              </Element>
            </div>
          </div>
          {/* Fragenteil */}
          <div className="container pt-5 my-5">
            <div className="text-center m-4">
              <h2>Überprüfe dein Wissen</h2>
              <p className="col-lg-11 mx-auto">
                Mit den richtigen Antworten kommst du weiter!
              </p>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-11 text-start">
                <form onSubmit={handleSubmit}>
                  {questions.map((question, index) => (
                    <div key={index} className="mb-4">
                      <p className="fs-4">{question.question}</p>{" "}
                      {question.options.map((option) => (
                        <div key={option.value} className="form-check">
                          <input
                            className="form-check-input me-2"
                            type="radio"
                            name={`question${index}`}
                            value={option.value}
                            checked={selectedAnswers[index] === option.value}
                            onChange={() =>
                              handleAnswerChange(index, option.value)
                            }
                          />
                          <label className="form-check-label fs-5">
                            {option.label}
                          </label>{" "}
                        </div>
                      ))}
                    </div>
                  ))}
                  {error && <p className="text-danger">{error}</p>}
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary">
                      überprüfen
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* Ende Fragenteil */}
        </div>
      </div>
    </div>
  );
};

export default Chapter1_4;
